/**
 * 周期与「月」的换算工具，供套餐价格/流量按周期展示时复用。
 * 约定：year = 12 月，month = 1 月，week ≈ 1/4.33 月，day ≈ 1/30 月。
 */

/** 将周期换算为等效月数（用于单价、总流量等） */
export function durationToTotalMonths( amount: number, unit: string ): number {

    const u = ( unit || 'month' ).toLowerCase();
    if ( u === 'year' ) return amount * 12;
    if ( u === 'month' ) return amount;
    if ( u === 'week' ) return ( amount * 12 ) / 52;
    if ( u === 'day' ) return amount / 30;
    return amount;

}

/** 根据周期与总价计算等效月单价 */
export function pricePerMonth( totalPrice: number, amount: number, unit: string ): number {

    const months = durationToTotalMonths( amount, unit );
    return months > 0 ? totalPrice / months : 0;

}
